import * as React from "react";
import { useEffect } from "react";
import { JSX } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { COMMAND_PRIORITY_EDITOR, createCommand } from "lexical";
import { $insertNodeToNearestRoot } from "@lexical/utils";
import { $createImageNode, ImageNode } from "./ImageNode";

export const INSERT_IMAGE_COMMAND = createCommand<{
  src: string;
  altText: string;
}>();

export function ImagePlugin(): JSX.Element | null {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (!editor.hasNodes([ImageNode])) {
      throw new Error("ImagesPlugin: ImageNode not registered on editor");
    }

    return editor.registerCommand(
      INSERT_IMAGE_COMMAND,
      (payload) => {
        const { src, altText } = payload;
        const imageNode = $createImageNode(src, altText);
        $insertNodeToNearestRoot(imageNode);

        return true;
      },
      COMMAND_PRIORITY_EDITOR,
    );
  }, [editor]);

  return null;
}
